import { useState } from "react";
import CodeIcon from "../Svgs/CodeIcon";
import SaleLinkIcon from "../Svgs/SaleLinkIcon";
import WalletIcon from "../Svgs/WalletIcon";
import SaleLinkModal from "./SaleLinkModal";
import { formatLabel } from "../../_helper";
import { USER_TYPES_CATEGORIES } from "../../constants/globals";
import UpdatePartnerProfileImage from "./UpdatePartnerProfileImage";
import { Link } from "react-router-dom";

const UserProfileHeader = ({ data, currentClientCategory }) => {
  const [openModal, setOpenModal] = useState(null); // 'SALE_LINK' or 'REFERRAL_CODE'

  const onClose = () => setOpenModal(null);

  const modalOptions = {
    SALE_LINK: {
      title: "Sale Link",
      icon: <SaleLinkIcon className="tw-inline-block" />,
      value: data?.salesLink,
    },
    REFERRAL_CODE: {
      title: "Referral Code",
      icon: <CodeIcon className="tw-inline-block" />,
      value: data?.referralCode,
    },
  };

  return (
    <div className="tw-bg-white tw-p-4 tw-pe-0 tw-rounded-lg tw-shadow-lg">
      <div className="tw-flex tw-justify-between tw-mb-4 max-sm:tw-flex-col tw-gap-6">
        <div className="tw-flex tw-items-center tw-gap-6 max-lg:tw-flex-col">
          <div className="tw-flex tw-flex-col tw-items-center">
            <UpdatePartnerProfileImage profilePic={data?.profilePic} />
          </div>
          <div>
            <h4 className="!tw-mb-1 tw-text-lg">{data?.fullName}</h4>
            <p className="tw-text-[#00000099] tw-text-xs">{data?.email}</p>
            <div className="tw-flex tw-mt-2 tw-gap-2 tw-items-center tw-text-xs tw-text-gray-600">
              <span className="material-icons tw-text-sm">lock</span>
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  window.open("/privacyPolicy", "_blank");
                }}
                className="tw-flex tw-items-center  hover:tw-text-blue-600"
              >
                Privacy Policy
              </Link>

              <span className="material-icons tw-text-sm">gavel</span>
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  window.open("/termsOfuse", "_blank");
                }}
                className="tw-flex tw-items-center tw-gap-1 hover:tw-text-blue-600"
              >
                Terms of Use
              </Link>
            </div>
          </div>
        </div>

        {currentClientCategory === USER_TYPES_CATEGORIES.SERVICE_MARKETING && (
          <div>
            {Object.keys(data?.wallets || {}).map((wallet) => (
              <p className="custom-badge" key={wallet}>
                <WalletIcon className="tw-inline-block tw-me-2" />
                <span>{formatLabel(wallet ?? "")}: </span>
                <span>{data?.wallets[wallet]} e.m</span>
              </p>
            ))}
          </div>
        )}
      </div>

      {currentClientCategory === USER_TYPES_CATEGORIES.SERVICE_MARKETING && (
        <>
          <p className="tw-w-[70%] tw-h-[1px] tw-shadow-[0_4px_4px_0_#00000040] tw-mx-auto tw-bg-secondary/50"></p>
          <div className="tw-mx-auto xl:tw-w-1/3">
            <div className="tw-flex tw-justify-between tw-mt-4 tw-me-4">
              <ModalTrigger
                label="Sale Link"
                icon={<SaleLinkIcon />}
                onClick={() => setOpenModal("SALE_LINK")}
              />
              <ModalTrigger
                label="R.code"
                icon={<CodeIcon />}
                onClick={() => setOpenModal("REFERRAL_CODE")}
              />
            </div>
          </div>
        </>
      )}

      {openModal && (
        <SaleLinkModal
          title={modalOptions[openModal].title}
          icon={modalOptions[openModal].icon}
          value={modalOptions[openModal].value}
          isOpen={!!openModal}
          onClose={onClose}
        />
      )}
    </div>
  );
};

const ModalTrigger = ({ icon, label, onClick }) => (
  <div
    className="tw-flex tw-items-center tw-gap-3 tw-cursor-pointer"
    onClick={onClick}
  >
    <div className="tw-bg-secondary/50 tw-w-10 tw-h-10 tw-rounded-full tw-grid">
      <div className="tw-m-auto">{icon}</div>
    </div>
    <p className="tw-font-semibold tw-text-black">{label}</p>
  </div>
);

export default UserProfileHeader;
